module.exports = {
	"articleTitle1": "Michigan sweeps weekend matches going into conference play ...",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Varsity Tennis Center",
	"articleLink2": "https://www.michigandaily.com/section/womens-tennis/jason-rubinstein-difference-michigan-womens-tennis",
	"articleSnippet1": "Mar 12, 2017 ... The No. 10 Michigan men's tennis team wrapped up the last of its non-\nconference play with a weekend sweep at the Varsity Tennis Center.",
	"articleSnippet2": "Feb 20, 2016 ... The Michigan women's tennis team upset No. 2 North Carolina at the Varsity \nTennis Center on Saturday. Amanda Allen/Daily.",
	"totalMisc": 0,
	"articleTitle2": "Jason Rubinstein: The difference of Michigan women's tennis ",
	"address": "2250 S. State St. Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170409/ahz.TNM_.VSUSF_.2.5.17.206.jpg?itok=MMemjrOe",
			"author": "Arnold Zhou",
			"caption": "Freshman Connor Johnston paired with senior Jathan Malik to secure the doubles point from the No. 1 spot."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170122/sms.TNM_.vsColumbia.3.12.16.311.jpg?itok=uDms-XO0",
			"author": "File Photo",
			"caption": "Freshman Myles Schalet outperformed his opponent at the No. 3 singles spot Saturday."
		}
	],
	"position": {
		"lat": 42.253351,
		"lng": -83.743583
	},
	"tips": [],
	"articleLink1": "#",
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/varsitytenniscenter.json
// module id = 997
// module chunks = 0